import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Wand(props) {
  return (
    <Svg width={36} height={37} viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <Path
        d="M35.438 21.585a1.687 1.687 0 01-1.688 1.688h-1.688v1.687a1.687 1.687 0 01-3.374 0v-1.688H27a1.687 1.687 0 110-3.374h1.688V18.21a1.688 1.688 0 113.375 0v1.688h1.687a1.688 1.688 0 011.688 1.687zM7.875 10.897h1.688v1.688a1.687 1.687 0 003.374 0v-1.688h1.688a1.687 1.687 0 100-3.375h-1.688V5.835a1.687 1.687 0 00-3.374 0v1.687H7.875a1.687 1.687 0 100 3.376zm18 15.75h-.563v-.562a1.688 1.688 0 10-3.375 0v.563h-.562a1.687 1.687 0 100 3.375h.563v.562a1.687 1.687 0 003.375 0v-.563h.562a1.687 1.687 0 100-3.374zm5.363-14.79L11.647 31.449a2.813 2.813 0 01-3.977 0L4.76 28.54a2.813 2.813 0 010-3.978l19.592-19.59a2.813 2.813 0 013.977 0l2.91 2.908a2.812 2.812 0 010 3.978zM22.36 15.96l-2.109-2.11-12.705 12.7 2.109 2.11 12.705-12.7zm6.09-6.09L26.34 7.76l-3.7 3.7 2.11 2.11 3.7-3.7z"
        fill="#3E68FE"
      />
    </Svg>
  );
}

export default Wand;
